import type { IconProps } from './types';

export const EyeIcon = (props: IconProps) => {
  const { color = 'currentColor', size = 24, ref, ...other } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      {...other}
    >
      <path
        d="M12.0005 3C6.50055 3 4.7207 7 1.2207 12C4.7207 17 6.50055 21 12.0005 21C17.5005 21 19.2805 17 22.7805 12C19.2805 7 17.5005 3 12.0005 3Z"
        stroke={color}
        strokeWidth="1.5"
      />
      <path
        d="M15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z"
        stroke={color}
        strokeWidth="1.5"
      />
    </svg>
  );
};
